const MapButtons = (buttons) => {

    const newButtons = buttons.map((button) => {
        return { key: button.Key,
                 text: button.Text,
                 icon: button.Icon,
                 UIEvent: button.UIEvent,
                 primaryAction: button.PrimaryAction,
                 onFinish: button.OnFinish,
                 refreshConfig: button.RefreshConfig,
                 buttons: button.Buttons,
                 rules: button.Rules
                }
    })

    for (const rec of newButtons) {
        if (rec.buttons !== undefined && Array.isArray(rec.buttons)) {
            rec.buttons = rec.buttons.map((button) => {
                return { key: button.Key,
                         text: button.Text,
                         icon: button.Icon,
                         UIEvent: button.UIEvent,
                         primaryAction: button.PrimaryAction,
                         onFinish: button.OnFinish,
                         refreshConfig: button.RefreshConfig
                        }
            });
        }
    }

    return newButtons;

}

export default MapButtons;